"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DealerClient = void 0;
const headers = {
    'User-Id': '__userId__',
};
class DealerClient {
    constructor(authService, stage) {
        this.authService = authService;
        this.stage = stage;
        this.gdcTokenQueryString = (isWcar) => isWcar ? `gdc=myvw-wcar-${this.stage}` : `gdc=myvw-mbb-${this.stage}`;
        this.resourceHostId = `myvw-dealer-api-${stage}`;
    }
    async getServicePartners(vin, isWCar, brand, query) {
        let response;
        try {
            response = await this.authService.get(this.resourceHostId, `dealer/v1/dealers?${this.gdcTokenQueryString(isWCar)}&q=${query}&brand=${brand}&vin=${vin}`, headers);
            const json = await response.json();
            if (!response.ok) {
                throw new Error(response.statusText);
            }
            return json;
        }
        catch (error) {
            if (error instanceof Error) {
                throw new Error(error.message);
            }
            throw new Error('something went wrong');
        }
    }
    async getServicePartner(isWCar, brand, partnerNumber, country) {
        let response;
        try {
            response = await this.authService.get(this.resourceHostId, `dealer/v1/dealers/${country}/${brand}/${partnerNumber}?${this.gdcTokenQueryString(isWCar)}`, headers);
            const json = await response.json();
            if (!response.ok) {
                throw new Error(response.statusText);
            }
            return json;
        }
        catch (error) {
            if (error instanceof Error) {
                throw new Error(error.message);
            }
            throw new Error('something went wrong');
        }
    }
}
exports.DealerClient = DealerClient;
//# sourceMappingURL=DealerClient.js.map